// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

export const RentRepository = {

	/*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService

	],

	/*
	**  Set up the data
	*/

	data: () => ({

		new_rent: {
			id: null,
			type: 'rent_term',
			meta: {
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
				version: 1
			},
			attributes: {
				status: 'not_started',
				term: null,
				amount: 0,
				policy: {
					cycle: null,
					due_on: 0,
					late_by: 0,
					late_fee: 0,
					failed_payment_fee: 0
				},
				term_dates: {
					starting_at: null,
					ending_at: null
				},
				first_month: {
					charge_amount: 0,
					prorated: false
				},
				due_notification: {
					days_in_advance: 0
				},
				transaction_fees_policy: {
					set_policy: false,
					method_type: 'owner', // owner, resident
					resident: {
						fee_amount: 0,
						percentage: 0
					}
				}
			},
			metrics: {
				total_balance: 0,
				total_charges: 0,
				total_late: 0,
				total_paid: 0,
				total_paid_amount: 0,
				total_remaining: 0,
				total_created_invoices: 0
			},
			links: null,
			relationships: {
				property: null,
				user: firebaseAuth.currentUser.uid,
				unit: null,
				resident: null,
				lease: null
			}
		}

	}),

	/*
	**  Set the methods
	*/

	methods: {

        resetNewRentProp: function() {

			// Reset the prop
			this.new_rent = {
				id: null,
				type: 'rent_term',
				meta: {
					created_at: moment().unix(),
					updated_at: moment().unix(),
					deleted_at: null,
					app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
					version: 1
				},
				attributes: {
					status: null,
					term: null,
					amount: 0,
					policy: {
						cycle: null,
						due_on: 0,
						late_by: 0,
						late_fee: 0,
						failed_payment_fee: 0
					},
					term_dates: {
						starting_at: null,
						ending_at: null
					},
					first_month: {
						charge_amount: 0,
						prorated: false
					},
					due_notification: {
						days_in_advance: 0
					},
					transaction_fees_policy: {
						set_policy: false,
						method_type: 'owner', // owner, resident
						resident: {
							fee_amount: 0,
							percentage: 0
						}
					}
				},
				metrics: {
					total_balance: 0,
					total_charges: 0,
					total_late: 0,
					total_paid: 0,
					total_paid_amount: 0,
					total_remaining: 0,
					total_created_invoices: 0
				},
				links: null,
				relationships: {
					property: null,
					user: firebaseAuth.currentUser.uid,
					unit: null,
					resident: null,
					lease: null
				}
			}

		},

    }

}